var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1.5"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]}),(_vm.required)?_c('span',{staticClass:"tw:text-red-500 tw:ml-0.5"},[_vm._v("*")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }